import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"wolf-alice"> = {
  appId: "wolf-alice",
  cookiePrefix: "wa",
  lang: "EN",
  admins: {
    mfaEnabled: true,
    otpExpiration: Duration.minutes(10),
    sessionDuration: Duration.minutes(20)
  },
  artist: {
    name: "Wolf Alice"
  },
  meta: {
    description: "Wolf Alice"
  },
  emailSender: {
    name: "Wolf Alice",
    email: "wolfalice@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x0ad4eab71ba334e0e182a6939bac7ca4f70a60e8"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: "https://store.wolfalice.co.uk",
  socialLinks: [
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://youtube.com/c/WolfAliceMusic"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/3btzEQD6sugImIHPMRgkwV"
    },
    {
      platform: SocialPlatform.AppleMusic,
      label: "Apple Music",
      href: "https://music.apple.com/br/artist/wolf-alice/589384117?ls"
    },
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://instagram.com/wolfaliceband"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/wolfalicemusic"
    },
    {
      platform: SocialPlatform.SoundCloud,
      label: "SoundCloud",
      href: "https://soundcloud.com/wolfalice"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://tiktok.com/@wolfalicemusic"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://facebook.com/wolfalicemusic"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 72
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 72
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: "https://www.sonymusic.co.uk/privacy",
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
